import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { useAuth } from "../pages/AuthContext";

const RealtimeCtx = createContext(null);

export function RealtimeProvider({ children }) {
    const { user: authUser } = useAuth(); // deve gi� esistere nel tuo progetto
    const [richiesteUtente, setRichiesteUtente] = useState([]);
    const [richiesteOperatore, setRichiesteOperatore] = useState([]);
    const [operatori, setOperatori] = useState([]);
    const [chats, setChats] = useState([]);
    const [loadingRT, setLoadingRT] = useState(true);

    useEffect(() => {
        // finch� non c�� l�utente evitiamo listener inutili
        if (!authUser) {
            setRichiesteUtente([]);
            setRichiesteOperatore([]);
            setChats([]);
            setLoadingRT(false);
            return;
        }

        const unsubs = [];

        // 1) Richieste lato utente (dove l�utente � il creatore della richiesta)
        {
            const q1 = query(
                collection(db, "richieste_servizio"),
                where("uid_utente", "==", authUser.uid),
                orderBy("created_at", "desc")
            );
            unsubs.push(onSnapshot(q1, snap => {
                setRichiesteUtente(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            }));
        }

        // 2) Richieste lato operatore (assegnate a me o in attesa se preferisci)
        {
            const q2 = query(
                collection(db, "richieste_servizio"),
                where("operatore_assegnato", "==", authUser.uid)
            );
            unsubs.push(onSnapshot(q2, snap => {
                setRichiesteOperatore(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            }));
        }

        // 3) Operatori (per elenco/nuovi arrivi � puoi filtrare per citt� se vuoi)
        {
            const q3 = query(collection(db, "operatori"));
            unsubs.push(onSnapshot(q3, snap => {
                setOperatori(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            }));
        }

        // 4) Chat (solo quelle in cui sono coinvolto)
        {
            const q4 = query(
                collection(db, "chats"),
                where("partecipanti", "array-contains", authUser.uid),
                orderBy("updated_at", "desc")
            );
            unsubs.push(onSnapshot(q4, snap => {
                setChats(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            }));
        }

        setLoadingRT(false);
        return () => unsubs.forEach(u => u());
    }, [authUser]);

    // Count dinamici utili per badge/tab
    const counts = useMemo(() => {
        const confermate = richiesteUtente.filter(r => r.stato === "confermato").length;
        const annullate = richiesteUtente.filter(r => r.stato === "annullata").length;
        const attesaPag = richiesteUtente.filter(r => r.stato === "attesa_conferma_pagamento").length;
        const daRecensire = richiesteUtente.filter(r =>
            r.stato === "confermato" && r.giorno_preferito && r.orario_fine && !r.recensita
        ).length;
        return { confermate, annullate, attesaPag, daRecensire };
    }, [richiesteUtente]);

    const value = useMemo(() => ({
        loadingRT, richiesteUtente, richiesteOperatore, operatori, chats, counts
    }), [loadingRT, richiesteUtente, richiesteOperatore, operatori, chats, counts]);

    return <RealtimeCtx.Provider value={value}>{children}</RealtimeCtx.Provider>;
}

export function useRealtime() {
    const ctx = useContext(RealtimeCtx);
    if (!ctx) throw new Error("useRealtime deve essere usato dentro <RealtimeProvider>");
    return ctx;
}
